import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/types'
import type { PopupInterceptStatCardKey } from './popup-intercept-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    totalIntercepted: { default: 0 },
    todayIntercepted: { default: 0 },
    adPopupSoftwareCount: { default: 0 },
    involvedTerminals: { default: 0 }
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, locale } = useI18n()
const statisticsItems = computed((): StatisticsCardItem[] => {
  void locale.value
  const ad = props.adPopupSoftwareCount ?? 0
  const term = props.involvedTerminals ?? 0
  return [
    { label: t('popupIntercept.statTotalIntercepted'), value: props.totalIntercepted, span: 6, clickable: false },
    { label: t('popupIntercept.statTodayIntercepted'), value: props.todayIntercepted, span: 6, clickable: false },
    {
      label: t('popupIntercept.statAdPopupCount'),
      value: ad,
      span: 6,
      clickable: ad > 0,
      events: {
        click: () => {
          if (ad <= 0) return
          emit('statClick', 'adPopupSoftware')
        }
      }
    },
    {
      label: t('popupIntercept.statInvolvedTerminals'),
      value: term,
      span: 6,
      clickable: term > 0,
      events: {
        click: () => {
          if (term <= 0) return
          emit('statClick', 'involvedTerminals')
        }
      }
    }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})